module.exports = __webpack_public_path__ + "static/img/200187.871e666c.png";